import React, { useContext, useMemo } from "react";
import "./index.css";
import { Controller, useForm } from "react-hook-form";
import { PerguntaContext } from "../../../../../contexts/PerguntaContext";
import { QuestionarioContext } from "../../../../../contexts/QuestionarioContext";
import { trackPromise } from "react-promise-tracker";
import QuestionarioService from "../../../../../services/QuestionarioService";
import { successToast } from "../../../../../components/DommusToast";
import Swal from "sweetalert2";
import { Button, Col, Form, Row } from "react-bootstrap";
import DommusRequiredSpan from "../../../../../components/DommusRequiredSpan";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";

export function AddPerguntaForm({ questionario, closeModal }) {
    const {
        handleSubmit,
        control,
        formState: { errors },
        setError,
    } = useForm();
    const { listaPerguntas } = useContext(PerguntaContext);
    const { adicionarPergunta } = useContext(QuestionarioContext);

    const perguntasOptions = useMemo(() => {
        let perguntasQuestionario = questionario.perguntas?.map(
            (pergunta) => pergunta.id_pergunta
        );

        return listaPerguntas.length
            ? listaPerguntas
                .filter(
                    (pergunta) => !perguntasQuestionario?.includes(pergunta.id_pergunta)
                )
                .map((pergunta) => {
                    return { value: pergunta.id_pergunta, label: pergunta.enunciado };
                })
            : [];
    }, [listaPerguntas, questionario]);

    const handleOnSubmit = (data) => {
        let dados = {};

        if (data.perguntas.length) {
            dados = {
                perguntas: data?.perguntas.map((pergunta) => pergunta.value),
            };

            trackPromise(
                QuestionarioService.addPerguntasQuestionario(
                    questionario.id_questionario,
                    dados
                )
            )
                .then((response) => {
                    adicionarPergunta(questionario.id_questionario, response.data);
                    successToast.fire("Adicionado perguntas com sucesso!!");
                    closeModal();
                })
                .catch((erro) => {
                    Swal.fire({
                        titleText: "Ooops...",
                        text:
                            "Ocorreu um erro ao tentar adicionar as perguntas: " +
                            erro?.response?.data ?? erro,
                        icon: "error",
                    });
                });
        } else {
            setError("perguntas", { type: "custom", message: "Vazio" });
        }
    };

    return (
        <Form onSubmit={handleSubmit(handleOnSubmit)} className="add-pergunta-form">
            <Row>
                <Col md="12" className="mt-3">
                    <Form.Label>
                        Perguntas:
                        <DommusRequiredSpan />
                    </Form.Label>
                    <Controller
                      name="perguntas"
                      control={control}
                      render={({ field }) => (
                          <Select
                              {...field}
                              isMulti
                              options={perguntasOptions}
                              onChange={(selected) => field.onChange(selected)}
                              value={field.value}
                          />
                      )}
                    />
                    {errors.perguntas && (
                        <small className="form-text text-danger">Campo Obrigatório*</small>
                    )}
                </Col>
            </Row>
            <Row className="justify-content-end mt-5 mx-2">
                <Button variant="success" type="submit">
                    <FontAwesomeIcon icon={faSave} /> Salvar
                </Button>
            </Row>
        </Form>
    );
}
